import Vue from 'vue'
import Vuex from 'vuex'
import decode from "jwt-decode";
import router from "./router";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: '',
    drawer: null,
    token: null,
    usuario: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
      if (state.usuario) {
        console.info("entre en local storage");
        console.log(state);
        localStorage.setItem("unico", state.usuario.unico);
        localStorage.setItem("nombre", state.usuario.nombre);
        localStorage.setItem("rol", state.usuario.rol);
        //local host
        //localStorage.setItem("ReportsUrl", "https://localhost:64818");
        //sunflower
        localStorage.setItem("ReportsUrl", "http://50.243.231.145/flexymaxapi");

      }
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
  },
  actions: {
    guardarToken({ commit }, token) {
      console.info("ingrese guardar token");
      commit("setToken", token);
      commit("setUsuario", decode(token));
      localStorage.setItem("token", token); //localStorage.setItem("doctor_uq", state.usuario.doctor);
    },
    autoLogin({ commit }) {
      let token = localStorage.getItem("token");
      if (token) {
        commit("setToken", token);
        commit("setUsuario", decode(token));
      }
      router.push({ name: "Dashboard" });
     
    },
    salir({ commit }) {
      console.log("salir ingresar");
      commit("setToken", null);
      commit("setUsuario", null);
      localStorage.removeItem("token");
      localStorage.removeItem("unico");
      localStorage.removeItem("nombre");
      localStorage.removeItem("ReportsUrl");
      localStorage.removeItem("email");
      router.push({ name: "Login" });
      
    }

  },
})
